// import * as Sentry from "@sentry/react"

import App from "./App"
import { Provider } from "react-redux"
import React from "react"
import ReactDOM from "react-dom/client"
import reportWebVitals from "./reportWebVitals"
import store from "store"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

reportWebVitals()
